<template>
  <div>
    <el-header height="50px">
      <sp-header :profile="profile" :currentOrg="currentOrg" :init="init" />
    </el-header>
    <div class="sp-container">
      <sp-menu-group :menuWidth="['40px', '200px']" :menuStatus.sync="status" :class="{'is-open': status}">
        <sp-menu v-if="menus.length" :menus="menus" :menuStatus="status" :select-id="selectId" @select-id="getSelectId" @page-config="getPageConfig" router pagePermissions width="200px" height="50px" />
      </sp-menu-group>
      <div class="sp-main" :style="{marginLeft:status ? '200px' : '40px'}">
        <router-view/>
      </div>
    </div>
    <el-footer height="auto">
      <sp-footer/>
    </el-footer>
    <el-tooltip placement="top" content="返回顶部">
      <back-to-top 
        transitionName="fade"
        :customStyle="myBackToTopStyle" 
        :visibilityHeight="300" 
        :backPosition="50">
      </back-to-top>
    </el-tooltip>
  </div>
</template>

<script>
import spHeader from "./sp-header";
import spFooter from "./sp-footer";
import BackToTop from '@/components/BackToTop'
import {mapMutations} from 'vuex'
export default {
  data() {
    return {
      status: true,
      selectId: "1",
      menus: [],
      profile: {},
      loginInfo: {},
      currentOrg: { id: "", name: "" },
      myBackToTopStyle: {
        'right': '20px',
        'bottom': '50px',
        'width': '40px',
        'height': '40px',
        'border-radius': '20px',
        'line-height': '40px', 
        'background': '#fff'
      },
      init: false
    };
  },
  components: {
    spHeader,
    spFooter,
    BackToTop
  },
  created() {
    setTimeout(() => {     
      this.getProfile();
    }, 500);
  },
  watch: {
    $route() {
      this.$route.path == "/" &&
        (this.selectId = sessionStorage.selectId = "1");
    }
  },
  computed: {
    pageConfig: {
      get() {
        return this.$store.state.pageConfig
      },
      set(value) {
        return this.setPageConfig(value)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPageConfig', 'checkYiXunDa'
    ]),
    //菜单选中的ID
    getSelectId(val) {
      this.selectId = sessionStorage.selectId = val;
      // console.log("选中的ID： " + val);
    },
    //获取页面权限
    getPageConfig(val) {
      this.pageConfig = val;
      // console.log("获取页面权限： " + JSON.stringify(val));
    },
    getProfile() {
      let _this = this;
      this.$request1
        .get(
          'user/profile',
          {
            timeout: 3000,
            withCredentials: true
          }
        )
        .then(function(response) {
          _this.profile = response.data;

          
          if (_this.profile.currentOrg !== null) {
            if (_this.profile.menus) {
              _this.menus = _this.profile.menus.menus;

              console.log(">>>>>>profile__null____login>")
              // _this.$route.path == "/login" && _this.$router.push({ path: "/" });

              localStorage.setItem("configs", JSON.stringify(_this.menus));


            } else {
              // _this.$router.push({ path: "/login" });
            }
            _this.currentOrg = _this.profile.currentOrg;
            if (_this.currentOrg.name.includes("逸迅达")) {
              _this.checkYiXunDa(true)
            } else{
              _this.checkYiXunDa(false)
            }
            sessionStorage.setItem("currentOrg", _this.profile.userName);
             _this.showException()
            return;
          }

          if (_this.currentOrg == null || _this.currentOrg.id === "") {
            sessionStorage.removeItem("currentOrg");
            _this.init = true;
            return;
          }
        })
        .catch(function(error) {
          if (error.response && error.response.status == 401) {
            // todo-login
            // var r = '/login';
            // window.location.href = r;
          }
        });
    },
    // todo 菜单栏展示订单费用异常数量 (一定要在获取到菜单以后才能加载，否则要插入的DOM节点不存在)
    showException(){
        let _this = this;
        this.$request1({
          url: '/order/charge/exception/query',
          method: "post",
          withCredentials: true,
          data: {
              currentPage: 1,
              pageSize: 1,
              status:0,
              type: 1
          }
        })
        .then(response => {
          let data = response.data;
          if (data.success) {
              var exceptionTotal = data.data.exceptionTotal;
                _this.createElement(exceptionTotal);
          } else {
            console.log("query exception error."+data.message);
          }
        })
        .catch(error => {
          console.log("get exception error.");
        });
    },
    createElement(num) {
      if (num > 0) {
        let spMenu = document.getElementsByClassName("sp-menu")[0];
        let items = spMenu.childNodes[4].getElementsByTagName("ul")[0];
        let target = items.getElementsByClassName("sp-menu-item")[14];
        let newChild = document.createElement("span");
        newChild.innerHTML = num;
        newChild.setAttribute("class", "abnormalChargeNums");
        newChild.style.position = "absolute";
        newChild.style.top = "15px";
        newChild.style.right = "15px";
        newChild.style.padding = "2px 5px";
        newChild.style.width = "35px";
        newChild.style.borderRadius = "12px";
        newChild.style.textAlign = "center";
        newChild.style.backgroundColor = "#ED6B75";
        newChild.style.color = "#fff";
        target.appendChild(newChild);
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../static/iconfont/iconfont.css";
.sp-main {
  transition: margin 0.3s;
  border-top: 1px solid #ddd;
  background-color: #f3f3f4;
  min-height: 93vh;
  min-height: calc(100vh - 109px);
  min-height: -webkit-calc(100vh - 109px);
  min-height: -moz-calc(100vh - 109px);
}
.sp-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/mainpage.vue